import 'antd/dist/reset.css';
import './configs/i18n';
import './styles.css';

import { ConfigProvider } from 'antd';
import React from 'react';
import { createRoot } from 'react-dom/client';

import Routes from './configs/routes';
import * as serviceWorker from './serviceWorker';

const BtnDefaultBG = '#E5E7EE';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <ConfigProvider
    theme={{
      hashed: false,
      token: {
        fontFamily: 'Barlow',
        colorPrimary: '#3FDDB4',
        colorPrimaryHover: '#63F7C6',
        colorPrimaryActive: '#21ECB9',
        borderRadius: 4
      },
      components: {
        Button: {
          colorText: '#373944',
          colorBgContainer: BtnDefaultBG,
          colorBorder: BtnDefaultBG,
          colorTextLightSolid: '#0a3d34',
          fontSize: 14,
          fontSizeLG: 14,
          fontWeightStrong: 500
        },
        Layout: {
          bodyBg: '#F9FBFA',
        },
        Table: {
          colorBgContainer: '#FFFFFF',
          colorTextHeading: 'var(--character-secondary)'
        },
        Modal: {
          padding: 0,
          paddingContentHorizontal: 0,
          paddingContentVertical: 0,
          paddingContentHorizontalLG: 0,
          paddingContentVerticalLG: 0
        }
      }
    }}
  >
    <Routes />
  </ConfigProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
